export var ContentsActionTypes;
(function (ContentsActionTypes) {
    ContentsActionTypes["FETCH_CONTENT_ATTEMPT"] = "FETCH_CONTENT_ATTEMPT";
    ContentsActionTypes["FETCH_CONTENT_SUCCESS"] = "FETCH_CONTENT_SUCCESS";
    ContentsActionTypes["FETCH_CONTENT_FAILURE"] = "FETCH_CONTENT_FAILURE";
})(ContentsActionTypes || (ContentsActionTypes = {}));
